import React, { useState } from "react";
// no layout import to avoid intrinsic props error
import { tokenService } from "../services/tokenService";
import { getApiUrl } from "../config/api";

const ChoosePlan: React.FC = () => {
  const [promo, setPromo] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [redeeming, setRedeeming] = useState(false);

  const redeem = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!promo.trim() || redeeming) return;
    setError(null);
    setSuccess(null);
    setRedeeming(true);
    try {
      const res = await tokenService.makeAuthenticatedRequest(
        getApiUrl("/api/billing/redeem"),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code: promo.trim() }),
        }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || "Ошибка активации");
      setSuccess("Тариф активирован!");
      window.location.href = "/";
    } catch (e: any) {
      setError(e?.message || "Ошибка активации");
    } finally {
      setRedeeming(false);
    }
  };

  return (
    <div className="relative min-h-[calc(100vh-65px)] overflow-x-hidden overflow-y-auto">
      <div className="pointer-events-none fixed inset-0 z-0 bg-gradient-to-b from-indigo-50 via-white to-white" />
      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-gray-900">
            Активация подписки по промокоду
          </h1>
          <p className="mt-2 text-gray-600">
            Введите промокод, чтобы мгновенно активировать доступ ко всем
            функциям.
          </p>
        </div>

        <div className="relative">
          <div
            className="absolute -inset-0.5 rounded-3xl bg-gradient-to-r from-indigo-300 via-purple-300 to-pink-300 blur opacity-60"
            aria-hidden="true"
          />
          <div className="relative rounded-3xl bg-white/90 backdrop-blur border border-gray-200 shadow-xl">
            <div className="p-6 sm:p-8">
              <div className="flex items-start gap-4">
                <div className="hidden sm:flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-indigo-600 text-white shadow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="h-6 w-6"
                  >
                    <path d="M3 7.5A2.5 2.5 0 0 1 5.5 5H14a2 2 0 0 1 2 2v.586a2 2 0 0 0 .586 1.414l1.414 1.414a2 2 0 0 1 0 2.828l-6.172 6.172a2 2 0 0 1-2.828 0L7.586 17.5A2 2 0 0 0 6.172 16.914L5 15.742V7.5z" />
                  </svg>
                </div>
                <div className="flex-1">
                  <div className="text-lg font-semibold text-gray-900">
                    Есть промокод?
                  </div>
                  <p className="mt-1 text-sm text-gray-600">
                    Активируйте его ниже — и сразу начните пользоваться
                    сервисом.
                  </p>

                  {error ? (
                    <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                      {error}
                    </div>
                  ) : null}
                  {success ? (
                    <div className="mt-4 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700">
                      {success}
                    </div>
                  ) : null}

                  <form onSubmit={redeem} className="mt-5">
                    <div className="flex flex-col gap-3 sm:flex-row">
                      <div className="relative flex-1">
                        <input
                          className="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 pr-10 text-base shadow-sm outline-none ring-0 transition focus:border-indigo-500 focus:shadow-md"
                          placeholder="Введите промокод"
                          value={promo}
                          onChange={(e) => setPromo(e.target.value)}
                          aria-label="Промокод"
                        />
                        {promo ? (
                          <button
                            type="button"
                            className="absolute inset-y-0 right-0 mr-2 inline-flex items-center rounded-lg p-2 text-gray-400 hover:text-gray-600"
                            onClick={() => setPromo("")}
                            aria-label="Очистить"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              className="h-5 w-5"
                            >
                              <path
                                fillRule="evenodd"
                                d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm2.28-10.22a.75.75 0 1 0-1.06-1.06L10 7.94 8.78 6.72a.75.75 0 0 0-1.06 1.06L8.94 9l-1.22 1.22a.75.75 0 1 0 1.06 1.06L10 10.06l1.22 1.22a.75.75 0 1 0 1.06-1.06L11.06 9l1.22-1.22Z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </button>
                        ) : null}
                      </div>

                      <button
                        className="inline-flex items-center justify-center rounded-xl bg-indigo-600 px-5 py-3 text-base font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
                        type="submit"
                        disabled={!promo.trim() || redeeming}
                      >
                        {redeeming ? (
                          <span className="inline-flex items-center gap-2">
                            <svg
                              className="h-5 w-5 animate-spin"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                                fill="none"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                              ></path>
                            </svg>
                            Активируем…
                          </span>
                        ) : (
                          "Активировать"
                        )}
                      </button>
                    </div>
                    <div className="mt-3 text-xs text-gray-500">
                      Если у вас нет промокода, свяжитесь с поддержкой.
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChoosePlan;
